
import '../App.css';
import Header from '../components/Header';
import Director from '../components/Director';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <Director/>
    <Footer/>
    </div>
  );
}

export default App;
